var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { useMergedRef } from '../_internal/useMergedRef';
import { Icon } from '../Icon';
import { useHasColoredBackground } from '../useHasColoredBackground';
import { withLabel } from '../withLabel';
import { Options } from './Options';
import { SelectContext } from './Select.context';
import { useSelect } from './Select.hooks';
import { ElementLeftContainer, IconsContainer, ElementRightContainer, Placeholder, ResetIconContainer, SearchInput, SelectContainer, Line, } from './Select.style';
var InnerSelect = React.forwardRef(function (props, ref) {
    var _a;
    var _b = props.multi, multi = _b === void 0 ? false : _b, 
    // eslint-disable-next-line deprecation/deprecation
    _c = props.light, 
    // eslint-disable-next-line deprecation/deprecation
    light = _c === void 0 ? false : _c, _d = props.bare, bare = _d === void 0 ? false : _d, _e = props.small, small = _e === void 0 ? false : _e, _f = props.tiny, tiny = _f === void 0 ? false : _f, _g = props.filterable, filterable = _g === void 0 ? false : _g, _h = props.disabled, disabled = _h === void 0 ? false : _h, _j = props.canSelectAll, canSelectAll = _j === void 0 ? false : _j, _k = props.canReset, canReset = _k === void 0 ? true : _k, elementLeft = props.elementLeft, elementRight = props.elementRight, selectAllLabel = props.selectAllLabel, value = props.value, options = props.options, placeholder = props.placeholder, onChange = props.onChange, rest = __rest(props, ["multi", "light", "bare", "small", "tiny", "filterable", "disabled", "canSelectAll", "canReset", "elementLeft", "elementRight", "selectAllLabel", "value", "options", "placeholder", "onChange"]);
    var containerRef = useMergedRef(ref);
    var hasBackground = useHasColoredBackground();
    var _l = useSelect({
        onChange: onChange,
        options: options,
        multi: multi,
        value: value,
    }), state = _l[0], actions = _l[1];
    var context = React.useMemo(function () { return ({ multi: multi, canSelectAll: canSelectAll }); }, [multi, canSelectAll]);
    return (React.createElement(SelectContext.Provider, { value: context },
        React.createElement(SelectContainer, __assign({ ref: containerRef, "data-disabled": disabled, "data-open": state.isOpened, "data-background": hasBackground, "data-light": light, "data-small": small, "data-bare": bare, "data-tiny": tiny, "data-testid": "select-container", onClick: actions.onOpen, color: state.color, tabIndex: 0 }, rest),
            elementLeft && (React.createElement(ElementLeftContainer, null, elementLeft)),
            filterable && state.isOpened ? (React.createElement(SearchInput, { autoComplete: "off", "data-testid": "select-input", value: state.query, onChange: actions.onSearch, ref: function (inputRef) { return inputRef === null || inputRef === void 0 ? void 0 : inputRef.focus(); } })) : (React.createElement(Placeholder, { "data-testid": "select-placeholder", "data-empty": !state.label }, (_a = state.label) !== null && _a !== void 0 ? _a : placeholder)),
            React.createElement(IconsContainer, null,
                state.selectedOptions.length > 0 && canReset && (React.createElement(ResetIconContainer, null,
                    React.createElement(Icon, { "data-testid": "select-reset-icon", onClick: actions.onReset, icon: "close" }),
                    React.createElement(Line, null))),
                React.createElement(ElementRightContainer, null, elementRight !== null && elementRight !== void 0 ? elementRight : (React.createElement(Icon, { icon: state.isOpened ? 'chevron-north' : 'chevron-south' }))))),
        React.createElement(Options, { options: state.visibleOptions, open: state.isOpened, allSelected: state.areAllOptionsSelected, onSelect: actions.onSelect, onSelectAll: actions.onSelectAll, focusedOption: state.focusedOption, selectAllLabel: selectAllLabel, onClose: actions.onClose, containerRef: containerRef })));
});
export var Select = withLabel({
    orientation: 'vertical',
})(InnerSelect);
//# sourceMappingURL=Select.js.map